var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.status == 'active')?_c('span',[_c('i',{staticClass:"mdi mdi-circle text-success"}),_vm._v(" 有効 ")]):(_vm.user.status == 'blocked')?_c('span',[_c('i',{staticClass:"mdi mdi-circle text-warning"}),_vm._v(" ブロックした ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }